import React, {Fragment} from "react";
import {ApplicationState, ConnectedReduxProps} from "@reducers/index";
import {Channel} from "@models/channel";
import ChannelForm from "@components/channels/Form";
import {injectIntl} from "react-intl";
import channelApi from "@api/channel";


interface PropsFromState {
  loading: boolean;
  data: Channel[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class ChannelFormPage extends React.Component<AllProps> {
  state = {
    channel: null,
    channel_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.channel_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    channelApi
      .getItem({
        params: {
          id: this.state.channel_id
        }
      })
      .then(({data}) => {
        this.setState({
          channel: data
        });
      })
      .catch(error => {
      });
  };

  updateRequest = ({payload, params, onSuccessCallback, onErrorCallback}) => {
    channelApi.update({
      payload, params
    })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };

  createRequest = ({payload, onSuccessCallback, onErrorCallback}) => {
    channelApi.create({
      payload
    })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };

  getContent = () => {
    if (this.state.channel_id && !this.state.channel) {
      return null;
    }

    return (
      <ChannelForm
        channel={this.state.channel}
        intl={this.props.intl}
        listUrl={"/channels"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(ChannelFormPage)
